import { DefaultModalLayout } from "../../../../components/modal/layouts/default-modal-layout";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../components/fonts/font-props";
import { Button } from "../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import { Note, NOTE_TYPE } from "../../../../components/note/note";
import { FC } from "react";
import './missing-translations-modal.scss';
import IframeService from "../../../../services/iframe-service/iframe-service";
import { rootContainer, TYPE } from "../../../../services/container/root";

interface IProps {
    setIsOpen: (isOpen: boolean) => void;
}

const MissingTranslationsModal: FC<IProps> = ({ setIsOpen }) => {
    const iframeService = rootContainer.get<IframeService>(TYPE.IframService);

    return (
        <DefaultModalLayout onCloseClicked={() => setIsOpen(false)} isCloseDisabled={false}>
            <div className="missing-translations-modal">
                <Note
                    type={NOTE_TYPE.WARNING}
                    caption="SOME TRANSLATIONS ARE MISSING"
                    body={"Missing translation entries detected. This could result in shoppers seeing English text instead of their preferred language."}
                />

                <FontBody1 color={FONT_COLOR.PRIMARY3}>Please update your file now to ensure a smooth experience and avoid disruptions.</FontBody1>

                <div className="missing-translations-modal-buttons">
                    <Button text="Cancel" onClick={() => setIsOpen(false)} variant={BUTTON_VARIANTS.Tertiary} />
                    <Button
                        text="Update now"
                        onClick={() => {
                            iframeService.redirectParentFrame('/dashboard/settings/portal-and-emails-languages');
                        }}
                        variant={BUTTON_VARIANTS.Primary}
                        hasLoader={false}
                        isLoading={false}
                    />
                </div>
            </div>
        </DefaultModalLayout>
    );
}

export default MissingTranslationsModal;